const Form = {
  FUNC_LOAD: 'onload',
  FUNC_RELOAD: 'onreload',
  PROPERTY_FORM_INVISIBLE: 'frmInvisible',
  PROPERTY_FORM_HIDDEN: 'frmHidden',
  PROPERTY_FORM_CLOSED: 'prpFrmClosed',
  PROPERTY_FORM_TAB: 'frmTab',
  PROPERTY_FORM_HIGHLIGHT: 'frmHighlight',
  PROPERTY_FORM_DONT_FIRE: 'frmDontFire',
  PROPERTY_FORM_READONLY: 'readOnly',
  SIGNABLE_FORM: 'signableForm',
  MARKED_TO_SIGN: 'markedToSign',
  REQUIRED_SIGN: 'requiredSignableForm',
  LANGUAGES: 'langs',
} as const;

export default Form;
